import { Component, Input, ViewChild } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';
import { Select } from 'ionic-angular';
import { TotvsNotificationProvider } from '../../providers/notification/totvs-notification-provider';
import { TranslateService } from '@ngx-translate/core';
import { TotvsTranslateProvider } from '../../providers/translate/totvs-translate-provider';


const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<span class="var-optional" *ngIf="variable.optional">({{'COMMON.OPTIONAL' | tTranslate}})</span>
<ion-item no-lines no-padding>
  <ion-range [(ngModel)]="variableValue.value" min="{{variable.minValue}}" (ionChange)="onChangeCallback()" max="{{variable.maxValue}}">
    <ion-label range-left class="range-label-left">{{variable.minValue}}</ion-label>
    <ion-label range-right class="range-label-right">{{variable.maxValue}}</ion-label>
  </ion-range>
</ion-item>
<div class="var-value-label">
  <button style="float: left;" ion-button icon-only (click)="onMinusButtonClick()">
    <thf-icon name="minus-circle"></thf-icon>
  </button>
  
  <span class="{{getLegendClass()}}" (click)="onEditClick()">
    <span style="padding-left: 8px;">{{variableValue.asString}}</span>
    <span *ngIf="variable.suffix && variableValue.value != undefined" class="var-suffix">{{variable.suffix}}</span>
    <thf-icon name="edit" class="var-edit-icon"></thf-icon>
  </span>
  
  <button style="float: right;" ion-button icon-only (click)="onPlusButtonClick()">
    <thf-icon name="plus-circle"></thf-icon>
  </button>
</div>
`;

const CSS_STYLE = `
.range-label-left {
    font-weight: bold;
    font-size: 14px;
    padding-right: 8px;
  }

  .range-label-right {
    font-weight: bold;
    font-size: 14px;
    padding-left: 8px;
  }

  .range {
      padding: 0;
  }

  .range-bar {
    height: 4px !important;
    top: 20px !important;
    border-radius: 4px;
    background-color: #eee !important;
  }

  .range-bar-active {
    height: 4px !important;
    background-color: #0c9abe !important;
  }
  
  button {
    font-size: 24px !important;
    min-height: 26px !important;
    min-width: 26px;
    height: 26px !important;
    width: 26px;
    
    padding: 0 !important;
    padding-left: 4px !important;
    background-color: transparent !important;
    color: #ccc !important;
  }
`;

@Component({
    selector: 'variable-spinner',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableSpinnerComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;


    constructor(private _notificationProvider: TotvsNotificationProvider,
        private _totvsTranslate: TotvsTranslateProvider) {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "0",
            value: 0
        }
    }

    ngOnInit() {
        if (this.variable.defaultValue != null)
            this.setValue(this.variable.defaultValue);
        this.onChangeCallback();
    }

    onEditClick() {
        this._notificationProvider.presentPrompt(this.variable.description,
            [{
                name: 'value',
                type: 'number',
                value: this.variableValue.value
            }], [{
                text: this._totvsTranslate.instant('COMMON.CANCEL'),
                role: 'cancel',
                handler: data => {
                    console.log('Cancel clicked');
                }
            }, {
                text: this._totvsTranslate.instant('COMMON.CONFIRM'),
                handler: data => {
                    if (data.value)
                        this.setValue(data.value);
                    this.onChangeCallback();
                }
            }]
        );
    }

    onMinusButtonClick() {
        this.variableValue.value = +this.variableValue.value - 1
        this.setValue(this.variableValue);
        this.onChangeCallback();
    }

    onPlusButtonClick() {
        this.variableValue.value = +this.variableValue.value + 1;
        this.setValue(this.variableValue);
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue) {
        variableValue.value = +variableValue.value;
        if (isNaN(variableValue.value))
            return;

        this.variableValue = {
            asBoolean: (variableValue.value ? true : false),
            asString: this.variable.decimals ? variableValue.value.toFixed(this.variable.decimals) : String(variableValue.value),
            value: variableValue.value
        }
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.setValue(this.variableValue);
        this.callback(this);
    }
}
